import { createFileRoute } from '@tanstack/react-router'

import { MembershipDocumentsPage } from '@/features/membership/documents'

export const Route = createFileRoute('/_authenticated/benefits/documents')({
  component: MembershipDocumentsPage,
})
